<!--包装及规格参数-->
<template>
  <!--产品参数弹框-->
  <div class="spec-content">
    <!-- 头部点击跳转 -->
    <div class="top-title">
      <v-scroll-x :data="paraArr" role="tablist">
        <template v-slot="{ data: v, index }">
          <div
            class="inside"
            role="tab"
            tabindex="0"
            :aria-selected="index == mytabIndex ? 'true' : 'false'"
            :class="index == mytabIndex ? 'active' : ''"
            @click.stop="tabChange(index)"
          >
            <span>{{ v.name }}</span>
          </div>
        </template>
      </v-scroll-x>
    </div>
    <!-- 详细数据 -->
    <div class="detail" id="productSpecDetail">
      <div class="row detail-inside" v-for="v in paraArr" :key="v.id">
        <div class="title">{{ v.name }}</div>
        <div class="item" v-for="item in v.items" :key="item.id" tabindex="0">
          <img v-if="item.imgUrl" class="item-img" :src="item.imgUrl" alt />
          <div v-else class="item-text">
            <div class="text-left fs-30">{{ item.name }}</div>
            <!--规格说明是富文本-->
            <div class="text-right fs-36" v-html="item.value"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { common } from '@/utils'
export default {
  name: 'SpecPopup',
  data() {
    return {
      mytabIndex: -1,
      bol: true,
      barr: []
    }
  },
  computed: {
    ...mapState('detailv3', ['skuInfo']),
    paraArr() {
      return this.skuInfo.parameters.filter(item => item.isKey !== 2)
    }
  },
  mounted() {
    var that = this
    var arr = []
    this.$nextTick(() => {
      this.mytabIndex = 0
      Array.from(document.querySelectorAll('#productSpecDetail .detail-inside')).forEach(item => {
        arr.push(item.offsetTop)
      })
      this.barr = [...arr]
      that.bol = false
      document.querySelector('#productSpecDetail').addEventListener(
        'scroll',
        common.debounce(e => {
          if (that.bol) return
          var mySwiper = document.querySelector('.spec-content .swiper-container').swiper
          var specDetailDom = document.querySelector('#productSpecDetail')
          var num = specDetailDom.scrollTop
          arr.forEach((val, index) => {
            if (num > arr[index] && num < arr[index + 1]) {
              if (index == arr.length - 2) {
                var specScrollHeight = specDetailDom.scrollHeight
                var specOffsetHeight = specDetailDom.offsetHeight
                if (num + 2 > specScrollHeight - specOffsetHeight) {
                  mySwiper.slideTo(index)
                  that.mytabIndex = index + 1
                  return
                }
              }
              mySwiper.slideTo(index - 1)
              that.mytabIndex = index
            }
          })
          if (num > arr[arr.length - 1]) {
            mySwiper.slideTo(arr.length - 2)
            that.mytabIndex = arr.length - 1
          }
          if (num == arr[0]) {
            mySwiper.slideTo(0)
            that.mytabIndex = 0
          }
        }, 10)
      )
    })
  },
  methods: {
    tabChange(index) {
      this.mytabIndex = index
      if (index) {
        document.querySelector('.spec-content .swiper-container').swiper.slideTo(index - 1)
      }
      document.querySelector('#productSpecDetail').scrollTop = this.barr[index]
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss" />
